var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishWorkReTurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 15V13.2H10.75V10.8H15.4167V9L18.75 12L15.4167 15ZM14.0833 6C14.437 6 14.7761 6.12643 15.0261 6.35147C15.2762 6.57652 15.4167 6.88174 15.4167 7.2V8.4H14.0833V7.2H8.08333V16.8H14.0833V15.6H15.4167V16.8C15.4167 17.1183 15.2762 17.4235 15.0261 17.6485C14.7761 17.8736 14.437 18 14.0833 18H8.08333C7.72971 18 7.39057 17.8736 7.14052 17.6485C6.89048 17.4235 6.75 17.1183 6.75 16.8V7.2C6.75 6.88174 6.89048 6.57652 7.14052 6.35147C7.39057 6.12643 7.72971 6 8.08333 6H14.0833Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishWorkReTurn);
export default __webpack_public_path__ + "static/media/FinishWorkReTurn.f11922ec6be808ee57244c58dcd1a9ff.svg";
export { ForwardRef as ReactComponent };